import { render, staticRenderFns } from "./PhotoPanel.vue?vue&type=template&id=a6b8049c&scoped=true&"
import script from "./PhotoPanel.vue?vue&type=script&lang=ts&"
export * from "./PhotoPanel.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoPanel.vue?vue&type=style&index=0&id=a6b8049c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b8049c",
  null
  
)

export default component.exports
import {QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QImg})
